import React from "react";

import { FileUploader } from "../../components/FileUploader";
import { Col, Row } from "reactstrap";
import { LABELS, NAMES } from "./Config";
import { FormikErrorText } from "../../components/FormikErrorText";
import { MediaType } from "../../constants";

let { UPLOAD_AUDIO, UPLOAD_THUMBNAIL } = LABELS;

const UploadContainer = ({ formik, setFieldValue, formValues, data }) => {
    const handleFileUpload = async (file, exactFile, fieldName) => {
        formik.setFieldValue(NAMES[fieldName], { file, exactFile }); // Store file and mediaId in form
    };

    const handleFileRemove = (fieldName) => {
        setFieldValue(NAMES[fieldName], null); // Clear file from form
    };

    return (
        <Row className="upload-container">
            <Col md={6}>
                <p className="mb-2 input-label">{UPLOAD_AUDIO}</p>
                <FileUploader
                    fileType={MediaType.AUDIO}
                    acceptedFileTypes={["m4a", "mp3", "wav"]}
                    supportedFormats="Supported format: .mp3, .m4a, .wav Max file size: 300MB"
                    onFileUpload={(file, exactFile) =>
                        handleFileUpload(file, exactFile, UPLOAD_AUDIO)
                    }
                    onFileRemove={() => handleFileRemove(UPLOAD_AUDIO)}
                    value={formValues[NAMES[UPLOAD_AUDIO]]} // Display current file
                    previewUrl={
                        data?.audios.length > 0
                            ? `${data?.audios[0]?.audioMedia?.location}${data?.audios[0]?.audioMedia?.thumbPath}`
                            : null
                    } // Existing audio preview
                    previewSize={data?.audios[0]?.audioMedia?.size}
                />
                <FormikErrorText formikInstance={formik} fieldName={NAMES[UPLOAD_AUDIO]} />
            </Col>
            <Col md={6}>
                <p className="mb-2 input-label">{UPLOAD_THUMBNAIL}</p>
                <FileUploader
                    fileType={MediaType.IMAGE}
                    supportedFormats="Supported format: .jpg, .png Max file size: 25MB"
                    acceptedFileTypes={["jpg", "png"]} // Define accepted types
                    maxFileSize={1} // Limit size to 1MB
                    onFileUpload={(file, exactFile) =>
                        handleFileUpload(file, exactFile, UPLOAD_THUMBNAIL)
                    }
                    onFileRemove={() => handleFileRemove(UPLOAD_THUMBNAIL)}
                    value={formValues[NAMES[UPLOAD_THUMBNAIL]]} // Display current file
                    previewUrl={
                        data?.croppedThumbnail
                            ? `${data?.croppedThumbnail?.location}${data?.croppedThumbnail?.thumbPath}`
                            : null
                    } // Existing croppedThumbnail
                    preview
                    previewSize={data?.croppedThumbnail?.size}
                    shouldCrop
                />
                <FormikErrorText formikInstance={formik} fieldName={NAMES[UPLOAD_THUMBNAIL]} />
            </Col>
        </Row>
    );
};

export default UploadContainer;
